import axios from 'axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const getAllFaqs = () => {
  return axios.request({
    baseURL,
    url: '/v1/frequentlyaskedquestions',
    method: 'GET',
  });
};
